export default __webpack_public_path__ + "static/media/aaa.fde6dad3.svg";